import ACREAPI from 'utils/services/ACREAPI';

const ENDPOINT_URL_PREFIX = 'payment';

export default class Checkout {
    static create = (data) => {
        return ACREAPI.authInstance().post(`${ENDPOINT_URL_PREFIX}/create`, data);
    };
}
